import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Occupancy } from './types';

export const OCCUPANCY_SLICE_NAME = 'occupancy';

const initialState: Occupancy = {
    initialAdultCount: null,
    initialChildCount: null,
};

const occupancySlice = createSlice({
    name: OCCUPANCY_SLICE_NAME,
    initialState,
    reducers: {
        setInitialAdultCount: (state, { payload: initialAdultCount }: PayloadAction<number>) => ({
            ...state,
            initialAdultCount,
        }),
        setInitialChildCount: (state, { payload: initialChildCount }: PayloadAction<number>) => ({
            ...state,
            initialChildCount,
        }),
    },
});

export const { setInitialAdultCount, setInitialChildCount } = occupancySlice.actions;

export const { reducer: occupancyReducer } = occupancySlice;
